// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export interface PortalConfig {
    features: Record<string, boolean>;
}

export const CONFIG: PortalConfig = {
    "features": {
        "enableAdminDashboard": true,
        "showThemeComponents": false,
        "redirectAdmin": true
    }
};
